import React, { createContext, useEffect, useState } from 'react';

export const ShopContext = createContext(null);

const getDefaultCart = () => {
  let cart = {};
  for (let index = 0; index <= 300; index++) {
    cart[index] = {};
  }
  return cart;
};

const getDefaultSizes = () => {
  let sizes = {};
  for (let index = 0; index <= 300; index++) {
    sizes[index] = { S: 0, M: 0, L: 0 };
  }
  return sizes;
};

const ShopContextProvider = (props) => {
  const [all_product, setAll_Product] = useState([]);
  const [CartItems, setCartItems] = useState(getDefaultCart());
  const [selectedSizes, setSelectedSizes] = useState(getDefaultSizes());
  const [userName, setUserName] = useState('');

  // ✅ استرجاع السلة من localStorage عند بداية التشغيل
  useEffect(() => {
    const storedCart = localStorage.getItem('cartItems');
    if (storedCart) {
      setCartItems(JSON.parse(storedCart));
    }
  }, []);

  // ✅ حفظ السلة في localStorage عند أي تغيير
  useEffect(() => {
    localStorage.setItem('cartItems', JSON.stringify(CartItems));
  }, [CartItems]);

  useEffect(() => {
    fetch('http://localhost:4000/allproducts')
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => setAll_Product(data))
      .catch((err) => console.error("Error fetching products:", err));

    if (localStorage.getItem('auth-token')) {
      fetch('http://localhost:4000/getcart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'auth-token': localStorage.getItem('auth-token'),
          'Content-Type': 'application/json',
        },
        body: '',
      })
        .then((response) => response.json())
        .then((data) => {
          const updatedCart = { ...getDefaultCart(), ...data };
          setCartItems(updatedCart);
        });

      fetch('http://localhost:4000/getusername', {
        method: 'GET',
        headers: {
          'auth-token': localStorage.getItem('auth-token'),
        },
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setUserName(data.userName);
          }
        });
    }
  }, []);

  const addToCart = (itemId, size = 'S') => {
    setCartItems((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [size]: (prev[itemId]?.[size] || 0) + 1,
      },
    }));

    setSelectedSizes((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [size]: (prev[itemId]?.[size] || 0) + 1,
      },
    }));

    if (localStorage.getItem('auth-token')) {
      fetch('http://localhost:4000/addtocart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'auth-token': localStorage.getItem('auth-token'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ itemId, size }),
      }).then((response) => response.json());
    }
  };

  const removeFromCart = (itemId, size) => {
    setCartItems((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [size]: Math.max((prev[itemId]?.[size] || 0) - 1, 0),
      },
    }));

    setSelectedSizes((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [size]: Math.max((prev[itemId]?.[size] || 0) - 1, 0),
      },
    }));

    if (localStorage.getItem('auth-token')) {
      fetch('http://localhost:4000/removefromcart', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'auth-token': localStorage.getItem('auth-token'),
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ itemId, size }),
      }).then((response) => response.json());
    }
  };

  const getTotalCartAmount = () => {
    let totalAmount = 0;
    for (const itemId in CartItems) {
      for (const size in CartItems[itemId]) {
        const quantity = CartItems[itemId][size];
        if (quantity > 0) {
          const product = all_product.find((p) => p.id === Number(itemId));
          if (product) {
            totalAmount += product.new_price * quantity;
          }
        }
      }
    }
    return totalAmount;
  };

  const getTotalCartItems = () => {
    let totalItem = 0;
    for (const itemId in CartItems) {
      for (const size in CartItems[itemId]) {
        totalItem += CartItems[itemId][size];
      }
    }
    return totalItem;
  };

  const contextValue = {
    getTotalCartItems,
    all_product,
    CartItems,
    addToCart,
    removeFromCart,
    getTotalCartAmount,
    userName,
    selectedSizes,
    setCartItems, // إضافة setCartItems إلى الـ contextValue
  };

  return (
    <ShopContext.Provider value={contextValue}>
      {props.children}
    </ShopContext.Provider>
  );
};

export default ShopContextProvider;

